export default __webpack_public_path__ + "img/process.fe9cb191.png";